<template>
  <div>
    <div class="h-panel-body padding-top">
      <Alert class="margin-right-left" type="info">
        支持从其他财务软件导出的 Excel 导入：科目、科目期初、记账凭证（文件内需包含对应 Sheet）。
        金额支持「借方/贷方」两列，也兼容「方向 + 金额」「期初余额」单列；凭证日期可早于账套启用期间。
        已存在的科目、期初余额和重复凭证号会自动跳过并在结果中列出。
      </Alert>

      <Card class="margin-right-left margin-top" dis-hover>
        <Row type="flex" align="middle" :space-x="15">
          <Cell>
            <span>数据来源：</span>
          </Cell>
          <Cell>
            <Select v-model="type" style="width:180px">
              <Option value="generic">通用 Excel 导入</Option>
              <Option value="lemon">柠檬云财务</Option>
              <Option value="yonyou">用友好会计</Option>
              <Option value="jdy">金蝶精斗云</Option>
              <Option value="zwy">金蝶账无忧</Option>
            </Select>
          </Cell>
          <Cell>
            <input ref="fileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onChoose">
            <Button icon="h-icon-file-upload" @click="$refs.fileInput.click()">{{ fileName || '选择 Excel 文件' }}</Button>
          </Cell>
          <Cell>
            <Button color="primary" :loading="loading" @click="doImport">开始导入</Button>
          </Cell>
          <Cell>
            <Button icon="h-icon-download" @click="downloadTemplate">下载导入模板</Button>
          </Cell>
        </Row>
      </Card>

      <Card v-if="result" class="margin-right-left margin-top" dis-hover title="导入结果">
        <Row :space-x="20" type="flex">
          <Cell><span class="stat-label">新增科目：</span><b>{{ result.subjectsInserted }}</b> 个</Cell>
          <Cell><span class="stat-label">科目期初：</span><b>{{ result.initialCount }}</b> 条</Cell>
          <Cell><span class="stat-label">导入凭证：</span><b>{{ result.voucherCount }}</b> 张</Cell>
        </Row>
        <Alert v-if="result.errors && result.errors.length" class="margin-top" type="warning">
          <div v-for="(err, i) in result.errors" :key="i">{{ err }}</div>
        </Alert>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncImport',
  data() {
    return {
      type: 'generic',
      file: null,
      fileName: '',
      loading: false,
      result: null
    };
  },
  methods: {
    onChoose(e) {
      let file = e.target.files[0];
      if (file) {
        this.file = file;
        this.fileName = file.name;
        this.result = null;
      }
      //允许重复选择同一个文件
      e.target.value = '';
    },
    downloadTemplate() {
      window.open(this.$api.pro.syncTemplateUrl(), '_blank');
    },
    doImport() {
      if (!this.file) {
        this.$Message.warning('请先选择需要导入的 Excel 文件');
        return;
      }
      this.loading = true;
      this.$api.pro.syncImport(this.type, this.file).then(({data}) => {
        this.result = data;
        this.$Message.success('导入完成');
      }).catch(() => {
        this.$Message.error('导入失败，请检查文件格式');
      }).finally(() => this.loading = false);
    }
  }
}
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 12px;
}
.stat-label {
  color: #808695;
}
</style>
